/* eslint-disable rxjs/finnish */
import { Injectable } from "@angular/core";
import { AdapterApiService } from "@core/services/adapter-api";
import { InitialClaimReport } from "@modules/report/models/report.interface";
import {
  ConfigurationInfo,
  ConfigurationService,
} from "@pgr-cla/cla-configuration";
import { first, Observable, Subject, switchMap } from "rxjs";

@Injectable()
export class ReportsService {
  constructor(
    private adapterApiService: AdapterApiService,
    private config: ConfigurationService
  ) {}

  getReport(claimNumber: string): Observable<InitialClaimReport> {
    return this.config.configuration$.pipe(
      first(
        (config: ConfigurationInfo) => config !== null && config !== undefined
      ),
      switchMap((config: ConfigurationInfo) => {
        return this.adapterApiService.get<InitialClaimReport>(
          config.adapterApiRouteUrl + "/lossviewerapi/v1/initial-claim",
          `/${claimNumber}`
        );
      })
    );
  }

  private _activeHeaderSubject$: Subject<string> = new Subject<string>();

  public setActiveHeader(anchorId: string): void {
    this._activeHeaderSubject$.next(anchorId);
  }

  getActiveHeader$(): Observable<string> {
    return this._activeHeaderSubject$;
  }
}
